import { render, staticRenderFns } from "./Accounts.vue?vue&type=template&id=2ced629e&scoped=true&"
import script from "./Accounts.vue?vue&type=script&lang=js&"
export * from "./Accounts.vue?vue&type=script&lang=js&"
import style0 from "./Accounts.vue?vue&type=style&index=0&id=2ced629e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ced629e",
  null
  
)

export default component.exports